import React, { Component } from "react";
import { connect } from "react-redux";
import { setSubMenuDirection, setSwitchSpace, setBackOffice } from "Actions";
import { VERTICAL, HORIZONTAL, HIDDEN_MENU_PAGES } from "Config";
import ClientsListLink from "./ClientsListLink";
import { isFiduciaryAccess, isClientAccess, getCookie, setCookie } from "Utils";
import DashboardLink from "./DashboardLink";
import CollaboratorSpaceLink from "./CollaboratorSpaceLink";
import DashboardsListLink from "./DashboardsListLink";
import SlideListLink from "./SlideListLink";
import CollaboratorsListLink from "./CollaboratorsListLink";
import SettingsLink from "./SettingsLink";
import _ from "i18n";
import { push } from "react-router-redux";
import { Select } from "antd";
import { SettingIcon } from "../../Common/Icons";
import { inIframe } from "Utils";
import styles from "./SubMenu.local.scss";
import { NotificationContainer } from "react-notifications";
class SubMenu extends Component {
  constructor(props) {
    super(props);
    const cookie = getCookie("SWITCH_USER");
    if (this.props.loggedAs === "MANAGER" && cookie) {
      this.props.switchSpace(cookie);
    }
    this.state = {
      switchUser: cookie ? cookie : "MANAGER",
      activated: false,
      backOfficeEnabled:
        this.props.user &&
        (this.props.user.type === "ADMIN" ||
          this.props.user.type === "ADMIN_SUPERVISOR")
    };
  }
  handleClickSwitchUser = () => {
    const { switchUser } = this.state;
    const { pushUrl } = this.props;
    if (switchUser === "COLLABORATOR") {
      pushUrl("/collaborator-space");
    } else {
      pushUrl("/");
    }

    let switchSpace =
      switchUser === "COLLABORATOR" ? "MANAGER" : "COLLABORATOR";
    this.setState({
      switchUser: switchSpace
    });
    this.setCookieSwitchUser(switchSpace);
    this.props.switchSpace(switchSpace);
  };

  handleClick = () =>
    this.props.setSubMenuDirection(
      this.props.subMenuDirection === VERTICAL ? HORIZONTAL : VERTICAL
    );

  setCookieSwitchUser = user => {
    const dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() + 86400 * 1000 * 3); //3j
    setCookie(`SWITCH_USER`, user, dtExpire, "/", "tamtam.pro");
  };
  handleBackOffice = () => {
    this.setState({
      activated: !this.state.activated
    });
    this.props.pushUrl("/");
    const dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() + 86400 * 1000 * 3); //3j
    setCookie(
      `BACK_OFFICE`,
      !this.state.activated,
      dtExpire,
      "/",
      "tamtam.pro"
    );
    this.props.setBackOffice(!this.state.activated);

    if (!this.state.activated === true) {
      setCookie(`SWITCH_USER`, "MANAGER", dtExpire, "/", "tamtam.pro");
      this.props.switchSpace("MANAGER");
      this.setState({
        switchUser: "MANAGER"
      });
    }
  };

  render() {
    const {
      auth,
      subMenuDirection,
      currentOrganization,
      subMenuDirectionToggle,
      currentNavPage,
      withoutHeader,
      backOffice,
      portail
    } = this.props;
    const { Option } = Select;
    const { loggedAs, spaceAs, preferences } = auth;
    if (loggedAs === "GUEST") return null;
    let allowManager = loggedAs === "MANAGER" && spaceAs === "MANAGER";
    let portailClient = portail === "CLIENT";
    let allowAccessToDashboardList =
      preferences && preferences.allowAccessToDashboardList === "1";
    let allowAccessToSlideList =
      preferences && preferences.allowAccessToSlideList === "1";
    let allowAccessToCollaboratorList =
      preferences && preferences.allowAccessToCollaboratorList === "1";
    let allowCollaboratorSpace =
      (loggedAs === "MANAGER" && spaceAs === "COLLABORATOR") ||
      loggedAs === "COLLABORATOR";

    let hideMenu = HIDDEN_MENU_PAGES.indexOf(currentNavPage) !== -1;

    if (hideMenu) return null;
    //   alert(backoffice);
    return (
      <nav
        id="subMenu"
        className={`sub-menu ${
          subMenuDirection === VERTICAL ? "vertical" : ""
        }`}
        style={{ display: "flex" }}
      >
        {withoutHeader && <NotificationContainer />}
        {subMenuDirectionToggle && !withoutHeader ? (
          <span
            className="flip-menu flex-column-center"
            onClick={this.handleClick}
          >
            <img
              className="icomoon"
              src="/img/icons/menu_direction.svg"
              alt={""}
            />
          </span>
        ) : null}
        <ul className="menu">
          {!backOffice ? (
            <div
              style={{ display: subMenuDirection === HORIZONTAL ? "flex" : "" }}
            >
              {isClientAccess(currentOrganization, portail) && (
                <DashboardLink organization={currentOrganization} />
              )}
              {isFiduciaryAccess(currentOrganization) &&
                allowCollaboratorSpace && <CollaboratorSpaceLink auth={auth} />}
              {isFiduciaryAccess(currentOrganization) &&
                !portailClient && <ClientsListLink auth={auth} />}
              {isFiduciaryAccess(currentOrganization) &&
                allowManager &&
                allowAccessToCollaboratorList &&
                !portailClient && <CollaboratorsListLink />}
            </div>
          ) : (
            ""
          )}

          {((isFiduciaryAccess(currentOrganization) && allowManager) ||
            backOffice) &&
          !portailClient ? (
            <div
              style={{ display: subMenuDirection === HORIZONTAL ? "flex" : "" }}
            >
              {allowAccessToDashboardList && <DashboardsListLink auth={auth} />}
              {allowAccessToSlideList && <SlideListLink auth={auth} />}
            </div>
          ) : (
            ""
          )}
          {isFiduciaryAccess(currentOrganization) &&
            allowManager &&
            withoutHeader &&
            !portailClient && <SettingsLink auth={auth} />}
        </ul>

        {withoutHeader && !portailClient ? (
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              marginRight: "2.5rem"
            }}
          >
            {this.state.backOfficeEnabled && (
              <div
                className={styles.back_office}
                style={{
                  background: !this.state.activated ? "#f8f9fa" : "#C6E8FE"
                }}
                onClick={this.handleBackOffice}
              >
                <SettingIcon fill="#28394d" size="12" />
                <span> BACK OFFICE </span>
              </div>
            )}

            {!backOffice && (
              <Select
                defaultValue={
                  this.state.switchUser === "COLLABORATOR"
                    ? _("collaboratorSpace")
                    : _("managerSpace")
                }
                style={{ width: 175, color: "white" }}
                onChange={this.handleClickSwitchUser}
                id={"select_switch_space"}
              >
                {this.state.switchUser === "COLLABORATOR" ? (
                  <Option
                    style={{
                      textAlign: "center"
                    }}
                    value={"managerSpace"}
                  >
                    {_("managerSpace")}
                  </Option>
                ) : (
                  <Option
                    style={{
                      textAlign: "center"
                    }}
                    value={"collaboratorSpace"}
                  >
                    {_("collaboratorSpace")}
                  </Option>
                )}
              </Select>
            )}
          </div>
        ) : (
          ""
        )}
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  currentOrganization: state.auth.currentOrganization,
  subMenuDirection: state.params.subMenuDirection,
  subMenuDirectionToggle: state.params.subMenuDirectionToggle,
  currentNavPage: state.params.currentNavPage,
  backOffice: state.params.backOffice,
  user: state.auth.user,
  withoutHeader: state.auth.withoutHeader,
  portail: state.auth.portail
});

const mapDispatchToProps = dispatch => ({
  setSubMenuDirection: direction => dispatch(setSubMenuDirection(direction)),
  pushUrl: url => dispatch(push(url)),
  switchSpace: user => dispatch(setSwitchSpace(user)),
  setBackOffice: activate => dispatch(setBackOffice(activate))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubMenu);



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/SubMenu.js